import { BorderStyle } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { dateConvertMiladiToShamsi } from "common/method/date";
import { sepratePriceFromComma } from "common/method/seprateNumberFromComma";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes } from "redux/payments/select_pec_payment_requests";

let useStyles = makeStyles(() => ({
  root: {
    height: "70vh",
    minHeight: "400px",
  },
  tables: {
    fontFamily: "iransans",
    "& thead th": {
      fontWeight: "500",
      fontSize: "18px",
      padding: "5px 0px",
      color: "#CECECE",
      borderBottom: "none",
      padding: "16px 0px",
      borderTop: "2px solid #e0e0e0",
      borderBottom: "2px solid #e0e0e0",
    },
    "& tbody tr td": {
      fontSize: "14px",
      padding: 0,
      border: "none",
    },
    "& tbody tr": {
      borderBottom: "1px solid #EFEFEF",
    },
    "& tbody tr:last-child ": {
      borderBottom: "none !important",
    },
  },
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
  emptyCard: {
    width: "98% !important",
    fontSize: 16,
    marginTop: 25,
    border: "1px solid black",
    height: 45,
    lineHeight: "2.8 !important",
    borderRadius: "4px !important",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "& td": {
    height: "50px !important",
  },
  "& td div": {
    lineHeight: 1.8,
    textAlign: "center",
    borderRadius: 100,
    display: "inline-block",
    width: 80,
    marginRight: 15,
    marginLeft: 15,
  },
  "& td span": {
    width: 150,
    display: "block",
  },
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th , &:last-child tr": {},
}));

export default function Index() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [state, setState] = useState([]);
  const reducer = useSelector(
    (state) => state.select_pec_payment_requests_Reducer,
  );

  useEffect(() => {
    if (reducer?.data?.length !== 0) {
      setState(reducer?.data?.results);
    }
  }, [reducer?.data]);

  useEffect(() => {
    dispatch({ type: actionTypes.selectPecPaymentRequestsAsync });
  }, []);

  const handelStatus = (key) => {
    switch (key) {
      case "REQUESTED":
        return "درانتظار";
      //TODO: remove useless comment status
      // case "PAYMENT_URL_GENERATE_SUCCESS":
      //   return "آماده پرداخت";

      // case "FAILED":
      //   return "خطای ایجاد تراکنش";

      // case "PENDING_FOR_VERIFY":
      //   return "در انتظار تایید";

      // case "TBS_PENDING":
      //   return "در انتظار TBS";

      case "TBS_SUCCESS":
        return "موفقیت آمیز";

      // case "TBS_FAILED":
      //   return "خطای TBS";

      case "VERIFIED_FAILED":
        return "تراکنش ناموفق";

      default:
        return "تراکنش ناموفق";
    }
  };

  return (
    <Grid item xs={12} md={7}>
      <Paper
        elevation={1}
        sx={{
          px: 4,
          py: 2,
          borderRadius: 4,
          backgroundColor: "#fff",
          height: "100%",
        }}
      >
        <Typography sx={{ p: 2, fontSize: 20 }}>تاریخچه واریزها</Typography>
        <TableContainer className={`${classes["root"]}`}>
          <Table
            stickyHeader
            aria-label="simple table"
            className={`${classes["tables"]} table-auto`}
          >
            <TableHead
              style={{ backgroundColor: "gray" }}
              className="bg-gray-100"
            >
              <TableRow>
                <TableCell style={{ color: "black" }} align="center">
                  ردیف
                </TableCell>
                <TableCell style={{ color: "black" }} align="center">
                  مبلغ
                </TableCell>
                <TableCell style={{ color: "black" }} align="center">
                  تاریخ
                </TableCell>
                <TableCell style={{ color: "black" }} align="center">
                  وضعیت
                </TableCell>
                <TableCell style={{ color: "black" }} align="center">
                  شماره کارت واریز کننده
                </TableCell>
                <TableCell style={{ color: "black" }} align="center">
                  توضیحات
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {state.length !== 0 && (
                <>
                  {state.map((items, index) => {
                    return (
                      <StyledTableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          backgroundColor: index % 2 === 1 ? "#e1e1e155" : "",
                        }}
                      >
                        <TableCell align="center">
                          <div>{index + 1}</div>
                        </TableCell>

                        <TableCell align="center">
                          <div>
                            {sepratePriceFromComma(
                              items?.body?.request_amount,
                            ) || "-"}
                          </div>
                        </TableCell>

                        <TableCell align="center">
                          <div>
                            {dateConvertMiladiToShamsi(
                              items?.body?.update_date,
                            ) || "-"}
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div style={{ minWidth: 120 }}>
                            {handelStatus(items?.body?.status)}
                          </div>
                        </TableCell>
                        <TableCell align="center" dir="ltr">
                          {items?.body?.pec_response?.CardNumberMasked || "-"}
                        </TableCell>
                        <TableCell align="center">
                          <div style={{ minWidth: 120 }}>
                            {items?.body?.description || "-"}
                          </div>
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                </>
              )}

              {reducer?.loading && (
                <StyledTableRow>
                  <TableCell align="center" colSpan={8}>
                    <div className="w-100 text-center mt-5">
                      <CircularProgress />
                    </div>
                  </TableCell>
                </StyledTableRow>
              )}

              {state.length === 0 && !reducer?.loading && (
                <StyledTableRow>
                  <TableCell align="center" colSpan={8}>
                    <div className={classes["emptyCard"]}>
                      تاریخچه ای یافت نشد
                    </div>
                  </TableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );
}
